// third party
import * as yup from 'yup';

const validationSchema = (intl) =>
    yup.object().shape({
        name: yup
            .string()
            .max(255, intl.formatMessage({ id: 'ui-comp-formvalidation-name-max', values: { maxValue: 255 } }))
            .required(intl.formatMessage({ id: 'ui-comp-formvalidation-name-required' })),
        description: yup.string().nullable(),
        lastName: yup
            .string()
            .max(255, intl.formatMessage({ id: 'ui-comp-formvalidation-lastname-max', values: { maxValue: 255 } }))
            .nullable(),
        username: yup
            .string()
            .max(255, intl.formatMessage({ id: 'ui-comp-formvalidation-username-max', values: { maxValue: 255 } }))
            .required(intl.formatMessage({ id: 'ui-comp-formvalidation-username-required' })),
        email: yup
            .string()
            .email(intl.formatMessage({ id: 'ui-comp-formvalidation-email-invalid' }))
            .lowercase(),
        employee: yup.object().shape({}).nullable(),
        passwordExpirationTime: yup
            .number()
            .min(30, intl.formatMessage({ id: 'ui-comp-formvalidation-passwordexpirationtime-min', values: { minValue: 30 } }))
            .max(999, intl.formatMessage({ id: 'ui-comp-formvalidation-passwordexpirationtime-max', values: { maxValue: 999 } }))
            .nullable(),
        groups: yup.array().of(yup.object().shape({})).nullable()
    });

export default validationSchema;
